<template>
    <div id="history_reduction" v-if="parseInt(reduction_info.id) > 0">
        <legend>Ставки на редукціоні</legend>
        
        <div v-if="is_load" class="py-4 d-flex align-items-center">
            <BSpinner small class="me-2" /> Завантаження...
        </div>
        
        <BTable
            v-else
            :items="rowsLocal"
            :fields="fields"
            responsive
            show-empty
            class="history_table cursor-pointer"
            :tbody-tr-attr="rowAttrs"
            @row-clicked="onRowClicked"
        >
            <!-- безопасные фоллбеки на бэковый формат -->
            <template #cell(quantity_fmt)="{ item }">
                {{ preferFmt(item.quantity_fmt, item.quantity) }}
            </template>
            <template #cell(max_price_fmt)="{ item }">
                {{ preferFmt(item.max_price_fmt, item.max_price) }}
            </template>
            <template #cell(latest_price_fmt)="{ item }">
        <span v-if="item.latest_price !== null && item.latest_price !== undefined">
          {{ preferFmt(item.latest_price_fmt, item.latest_price) }}
        </span>
                <span v-else>Пропозицій немає</span>
            </template>
            
            <!-- деталі: історія ставок -->
            <template #row-details="{ item }">
                <div class="details-wrap">
                    <table class="w-100 subtable">
                        <thead>
                        <tr class="subhead">
                            <th class="w-32"></th>
                            <th>Дата ставки</th>
                            <th>Організація</th>
                            <th class="text-end">Ставка</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="!item.history || !item.history.length">
                            <td colspan="4" class="py-2 text-center">Історія відсутня</td>
                        </tr>
                        
                        <tr
                            v-for="(h, idx) in item.history"
                            :key="h.id ?? (h.added + '-' + idx)"
                            :class="[{ 'back-red': idx === 0 && (h.is_competitor || h.user_id !== reduction_info.author_id),
                           'back-green': idx === 0 && (h.is_me || h.user_id === reduction_info.author_id) }]"
                        >
                            <td class="w-32"></td>
                            <td>{{ h.added_fmt ?? h.added }}</td>
                            <td>
                                <!-- если бэк не проставил флаги, сверяем по author_id -->
                                <template v-if="(h.is_me !== undefined) || (h.is_competitor !== undefined)">
                                    {{ h.is_competitor ? 'ставка Конкурента' : (h.user_company || '') }}
                                </template>
                                <template v-else>
                                    {{ h.user_id === reduction_info.author_id ? (h.user_company || reduction_info.company || '') : 'ставка Конкурента' }}
                                </template>
                            </td>
                            <td class="text-end">{{ h.cur_price_fmt ?? h.cur_price }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </BTable>
    </div>
</template>

<script>
import { BTable, BSpinner } from 'bootstrap-vue-next'

export default {
    name: 'application_reduction_info',
    components: { BTable, BSpinner },
    
    props: {
        tender_id: { type: Number, required: true },
        app_id:    { type: Number, required: true },
    },
    
    data() {
        return {
            is_load: false,
            reduction_info: { id: 0 },   // сюда придёт объект тендера (с reduction.build_items)
            fields: [
                { key: 'recid',            label: 'id', thStyle: { width: '40px' } },
                { key: 'title',            label: 'Лот' },
                { key: 'catalog_number',   label: 'Кат. номер' },
                { key: 'unit',             label: 'Од.' },
                { key: 'quantity_fmt',     label: 'Кількість',     class: 'text-end', thClass: 'text-end' },
                { key: 'max_price_fmt',    label: 'Стартова ціна', class: 'text-end', thClass: 'text-end' },
                { key: 'latest_price_fmt', label: 'Ціна торгів',   class: 'text-end', thClass: 'text-end' },
            ],
            rowsLocal: [],
        }
    },
    
    created() {
        this.load_reduction()
    },
    
    methods: {
        async load_reduction() {
            this.reduction_info = { id: 0 }
            this.rowsLocal = []
            this.is_load = true
            try {
                const { data } = await axios.post('/internal/reduction/reduction', {
                    app_id: this.app_id,
                    tender_id: this.tender_id,
                })
                this.reduction_info = data?.data ?? { id: 0 }
                // ожидаем structure: reduction.build_items (собрано на бэке)
                const items = this.reduction_info?.reduction?.build_items
                this.rowsLocal = Array.isArray(items)
                    ? items.map(r => ({ ...r, _showDetails: false })) // раскрыты по умолчанию, как на скрине
                    : []
            } catch (e) {
                console.error(e)
                EventBus.$emit('show_toast', {
                    err: e?.response?.data?.message ?? 'Помилка завантаження',
                    type: 'danger', title: e?.response?.data?.status ?? 'Error',
                    position: 'b-toaster-top-left',
                })
            } finally {
                this.is_load = false
            }
        },
        
        onRowClicked(item) {
            item._showDetails = !item._showDetails
        },
        
        rowAttrs(_item, type) {
            return type === 'row' ? { style: 'cursor:pointer', role: 'button', tabindex: '0' } : {}
        },
        
        preferFmt(fmt, raw) {
            return fmt ?? (raw ?? '')
        },
    },
}
</script>



<style scoped>
.history_table :deep(thead th) { font-weight: 600; }
.details-wrap { background: #f8f9fa; padding: 6px 8px; border-radius: 4px; }
.subtable { border-collapse: collapse; }
.subtable th, .subtable td { padding: 8px; }
.subhead { background: #e9ecef; }
.w-32 { width: 32px; }
.text-end { text-align: end; }

/* подсветка первого ряда (как на твоём скрине) */
.back-red   { background: #ff0000; color: #fff; }
.back-green { background: #d4edda; }
</style>
